module.exports = __webpack_public_path__ + "static/21-226f6e2c2c4923ca985b794f8a4c6f74.jpg";